export const USERNAME = 'username';
export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';
export const PERMISSIONS = 'permissions';
export const ROLE = 'role';
export const USER_ID = 'user_id';
